module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Notification2-9318593e4a59475995a567f6cc53db6f.svg";